import React, {createContext, useEffect, useState} from 'react'

import { connect } from 'react-redux'
import { getUser } from '../reducers/UserReducer'
import useLocalStorageOld from '../hooks/UseLocalStorage'
import moment from 'moment'
import LOCAL_STORAGE_KEYS from '../utils/localStorage'
import { OrderDirections, OrderBy, DEFAULT_NUMBER_OF_WEEKS } from '../utils/constants'
import { OwnershipFilters } from '../Components/shared/InternshipsManager/utils/constants'

const { INTERNSHIP_DATE, INTERNSHIP_FILTERS, INTERNSHIP_SEARCH } = LOCAL_STORAGE_KEYS.GLOBAL_FILTERS

export const DEFAULT_INTERNSHIP_FILTERS = Object.freeze({
  areStartedExcluded: false,
  institutions: [],
  order: { by: OrderBy.CREATED_AT, direction: OrderDirections.DESC },
  ownership: OwnershipFilters.ALL,
  schools: [],
  sections: [],
  sortDirection: OrderDirections.DESC,
  states: [],
  weeksShownCount: DEFAULT_NUMBER_OF_WEEKS
})

const mapStateToProps = state => ({
  user: getUser(state.getUser)
})

export const GlobalFiltersContext = createContext()

const GlobalFiltersProvider = ({ children, user }) => {
  const [internshipDate, setInternshipDate] = useLocalStorageOld(INTERNSHIP_DATE, moment().startOf('isoWeek'), true)
  const [internshipFilters, setInternshipFilters] = useLocalStorageOld(INTERNSHIP_FILTERS, DEFAULT_INTERNSHIP_FILTERS)
  const [internshipSearch, setInternshipSearch] = useLocalStorageOld(INTERNSHIP_SEARCH, '')
  const [selectedInstitution, setSelectedInstitution] = useState(null)

  return (
    <GlobalFiltersContext.Provider
      value={{
        internshipDate,
        internshipFilters,
        internshipSearch,
        selectedInstitution,
        setInternshipDate,
        setInternshipFilters,
        setInternshipSearch,
        setSelectedInstitution
      }}
    >
      {children}
    </GlobalFiltersContext.Provider>
  )
}

export default connect(mapStateToProps)(GlobalFiltersProvider)
